module.exports = __webpack_public_path__ + "static/img/people.eb9a4057.png";